import { CalendarDaysIcon } from '@heroicons/react/24/solid'

/**
 * Calendar Header Component
 * Displays the current month and year for the calendar
 *
 * @param {Object} props - Component props
 * @param {DateTime} props.currentMonth - Luxon DateTime object for current month
 */
const CalendarHeader = ({ currentMonth }) => {
  const monthYear = currentMonth.toFormat('MMMM yyyy')

  return (
    <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
      <h3 className="text-lg font-bold text-primary font-montserrat">
        {monthYear}
      </h3>
      <CalendarDaysIcon className="w-6 h-6 text-secondary" />
    </div>
  )
}

export default CalendarHeader
